export const MODAL_TYPES = {
  slideModal: 'slideModal',
  adminModal: 'adminCustomModal',
};
